class NutritionExpertsCarousel {
  constructor() {
    this.container = document.getElementById("nutrition-experts-container");
    this.slotsContainer = document.getElementById("experts-slots-container");
    this.slots = [
      ...this.slotsContainer.getElementsByClassName("nutrition-expert-slot"),
    ];
    this.allExperts = [];
    this.displayed = new Map(); // slotIndex -> expertTitle
    this.lastRemoved = null; // last removed expert title
    this.lastUsedSlot = null; // last slot index updated
    this.animationDuration = 600; // must match CSS duration (ms)

    this.init();
  }

  init() {
    this.allExperts = [
      ...this.container.getElementsByClassName("nutrition-expert-item"),
    ];

    if (this.allExperts.length < 3) {
      this.container.style.display = "block";
      this.slotsContainer.style.display = "none";
      return;
    }

    this.fillInitialSlots();
    setInterval(() => this.rotate(), 5000);
  }

  fillInitialSlots() {
    this.displayed.clear();

    this.slots.forEach((slot, index) => {
      const expert = this.getRandomExpert();
      if (expert) {
        slot.appendChild(expert.cloneNode(true));
        this.displayed.set(index, expert.querySelector("h3").textContent);
      }
    });
  }

  getRandomExpert() {
    const available = this.allExperts.filter((exp) => {
      const title = exp.querySelector("h3").textContent;
      return (
        ![...this.displayed.values()].includes(title) &&
        title !== this.lastRemoved
      );
    });

    if (available.length === 0) return null;
    return available[this.rand(available.length)];
  }

  async rotate() {
    const availableSlots = this.slots
      .map((_, i) => i)
      .filter((i) => i !== this.lastUsedSlot);
    const slotIndex = availableSlots[this.rand(availableSlots.length)];
    const slot = this.slots[slotIndex];
    const current = slot.querySelector(".nutrition-expert-item");
    if (!current) return;

    this.lastUsedSlot = slotIndex;
    this.lastRemoved = current.querySelector("h3").textContent;
    this.displayed.delete(slotIndex);

    // Animate out
    current.classList.add("fade-out");
    await this.delay(this.animationDuration);

    slot.innerHTML = "";
    const nextExpert = this.getRandomExpert();
    if (nextExpert) {
      slot.appendChild(nextExpert.cloneNode(true));
      this.displayed.set(slotIndex, nextExpert.querySelector("h3").textContent);
    }

    // Allow this expert to be reused again later
    setTimeout(() => {
      this.lastRemoved = null;
    }, 100);
  }

  // Utils
  rand(max) {
    return Math.floor(Math.random() * max);
  }

  delay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new NutritionExpertsCarousel();
});
